const ErrorRMW = ({
    code = '',
    message = '',
    data = {},
    httpStatus = '',
} = {}) => ({
    code: String(code),
    message: String(message),
    data, // type could be anything
    httpStatus: String(httpStatus),
});

export default ErrorRMW;
